// @ts-ignore
import playupOn from './balanceMenuAssets/playup-logo.svg';
import playupOff from './balanceMenuAssets/playup-logo-off.svg';
import draftstarsOn from './balanceMenuAssets/draftstars-logo.png';
import draftstarsOff from './balanceMenuAssets/draftstars-logo-off.png';
import playupAppIcon from './balanceMenuAssets/playup-app-icon.png';
import draftstarsAppIcon from './balanceMenuAssets/draftstars-app-icon.png';
import playupCash from './balanceMenuAssets/playup-bonus-cash.svg';
import draftstarsCash from './balanceMenuAssets/draftstars-bonus-cash.png';
import draftstarsTicket from './balanceMenuAssets/draftstars-bonus-ticket.png';
import playupMybets from './balanceMenuAssets/playup-mybets.svg';
import draftstarsMycontests from './balanceMenuAssets/draftstars-mycontests.svg';
import playupMyaccount from './balanceMenuAssets/playup-myaccount.svg';
import playupChat from './balanceMenuAssets/playup-chat.svg';
import playupLimits from './balanceMenuAssets/playup-limits.svg';
import draftstarsMyteams from './balanceMenuAssets/draftstars-myteams.svg';
import draftstarsHistory from './balanceMenuAssets/draftstars-history.svg';

const fantasyEnabled = process.env.REACT_APP_FANTASY_ENABLED === 'true';
const fantasyDefault = process.env.REACT_APP_DEFAULT_DRAFTSTARS === 'true';

export interface ClientAppConfig {
	name: string;
	clientId: number;
	link: string;
	logo: {
		on: string;
		off: string;
	};
	bonusTypes: Array<{
		type: string;
		name: string;
		icon: string;
	}>;
	balanceLinks: Array<{
		url: string;
		name: string;
		icon: string;
		counterKey?: string;
	}>;
	appIcon: string;
}

// NOTE: this config should be integrated in the brand config

const betting: ClientAppConfig = {
	name: 'PlayUp',
	clientId: 1,
	link: '/betting',
	logo: {
		off: playupOff,
		on: playupOn,
	},
	bonusTypes: [
		{
			type: 'cash',
			name: 'Bonus Cash',
			icon: playupCash,
		},
	],
	balanceLinks: [
		{ icon: playupMybets, url: '/betting/my-bets', name: 'My Bets', counterKey: 'active_bet_count' },
		{ icon: playupMyaccount, url: '/account/profile', name: 'My Account' },
		{ icon: playupLimits, url: '/account/limits', name: 'Deposit Limit' },
		{ icon: playupChat, url: '/betting/#livechat', name: 'Live Chat' },
	],
	appIcon: playupAppIcon,
};

const fantasy: ClientAppConfig = {
	name: 'Draftstars',
	clientId: 2,
	link: '/fantasy',
	logo: {
		off: draftstarsOff,
		on: draftstarsOn,
	},
	bonusTypes: [
		{
			type: 'cash',
			name: 'Bonus',
			icon: draftstarsCash,
		},
		{
			type: 'ticket',
			name: 'Tickets',
			icon: draftstarsTicket,
		},
	],
	balanceLinks: [
		{ icon: draftstarsMycontests, url: '/fantasy/my-contests', name: 'My Contests' },
		{ icon: draftstarsMyteams, url: '/fantasy/my-teams', name: 'My Teams' },
		{ icon: draftstarsHistory, url: '/fantasy/account/history', name: 'History' },
		{ icon: draftstarsMycontests, url: '/account/limits', name: 'Deposit Limits' },
	],
	appIcon: draftstarsAppIcon,
};

const getAvailableapps = () => {
	if (fantasyEnabled) {
		return fantasyDefault ? [fantasy, betting] : [betting, fantasy];
	} else {
		return [betting];
	}
};

export default getAvailableapps();
